'use strict';

import './billing.list.ctrl';
import './billing.plan.ctrl';

export default angular
  .module('main.billing', [
    'main.billingList.controller',
    'main.billingPlan.controller'
  ])
  .name;
